import React from 'react';
import { FaMapMarkerAlt, FaDirections } from 'react-icons/fa';
import './VenuePage.css';


const VenuePage = () => {
  return (
    <section className="venue-page fade-in-up">
      <div className="container venue-wrapper">
        <span className="badge venue-badge">Host Organization</span>
        <h1 className="venue-heading">Conference Venue</h1>
        <p className="venue-subtitle">How to visit the venue?</p>

        {/* Google Map Embed (no API key required) */}
        <div className="venue-map" aria-label="Google Map showing venue location">
          <iframe
            title="Venue Location Map - Brisbane Convention & Exhibition Centre"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7079.537212900605!2d153.0158198121544!3d-27.476462316897763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b915a0968742765%3A0x53b5b99532970ee3!2sBrisbane%20Convention%20%26%20Exhibition%20Centre!5e0!3m2!1sen!2sau!4v1752134276900!5m2!1sen!2sau"
            width="600"
            height="450"
            style={{ border: 0, width: '100%', height: '100%' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Venue address */}
        <div className="venue-address">
          <div className="venue-address-icon">
            <FaMapMarkerAlt />
          </div>
          <div className="venue-address-text">
            <div className="venue-address-name">Brisbane Convention &amp; Exhibition Centre</div>
            <div className="venue-address-lines">
              Merivale Street &amp; Glenelg Street,<br />
              South Brisbane QLD 4101, Australia
            </div>
            <a
              className="venue-directions-link"
              href="https://www.google.com/maps/dir/?api=1&destination=Brisbane+Convention+and+Exhibition+Centre"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaDirections /> Get directions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VenuePage;
